import React from 'react';
import styled from 'styled-components';

const TermsSection = ({ title, children }) => {
  return (
    <SectionContainer>
      <SectionTitle>{title}</SectionTitle>
      {children}
    </SectionContainer>
  );
};

const SectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
  @media (max-width: 640px) {
    gap: 16px;
  }
`;

const SectionTitle = styled.h2`
  align-self: stretch;
  color: #64636a;
  letter-spacing: -0.18px;
  font: 700 18px/140% Inter, -apple-system, Roboto, Helvetica, sans-serif;
  margin: 0;
  @media (max-width: 991px) {
    font-size: 16px;
  }
  @media (max-width: 640px) {
    font-size: 15px;
  }
`;

export const SectionText = styled.p`
  align-self: stretch;
  color: #64636a;
  letter-spacing: -0.08px;
  font: 400 16px/160% Inter, -apple-system, Roboto, Helvetica, sans-serif;
  margin: 0;
  @media (max-width: 991px) {
    font-size: 15px;
  }
  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

export const BulletPoint = styled.p`
  align-self: stretch;
  color: #64636a;
  letter-spacing: -0.08px;
  font: 400 16px/160% Inter, -apple-system, Roboto, Helvetica, sans-serif;
  margin: 0;
  @media (max-width: 991px) {
    font-size: 15px;
  }
  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

export default TermsSection;
